//entrypoint
import axios from 'axios';
import { getToken } from '../utils/constants';
import store from '../redux/store';
import { getFingerprint, hashFingerprint } from '../utils/commonFunctions';
import { sendSessionExpired, isEmbedded } from '../utils/webviewBridge';
const { dispatch } = store;

let cachedFingerprint = null;
const generateFingerprint = () => {
  if (!cachedFingerprint) {
    const fingerprintData = getFingerprint();
    cachedFingerprint = hashFingerprint(fingerprintData);
  }
  return cachedFingerprint;
};
export const AXIOS_INSTANCE_WITHOUT_INTERCEPTOR = axios.create();

AXIOS_INSTANCE_WITHOUT_INTERCEPTOR.interceptors.request.use((config) => {
  const token = getToken();
  config.headers['x-origin'] = 'e5dadeccee37872f08f365bb82005462';
  config.headers['x-browser-fingerprint'] = generateFingerprint();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
AXIOS_INSTANCE_WITHOUT_INTERCEPTOR.interceptors.response.use(
  (response) => {
    const token = getToken();

    if (response.headers.authorization && token) {
      dispatch({
        type: 'accountData/setToken',
        payload: response?.headers?.authorization.replace(/^Bearer\s+/i, ''),
      });
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      const currentToken = getToken();
      // Only treat as session expiry if user had an active session (token in Redux).
      // During SSO init, token is not in Redux yet — a 401 here is an API failure,
      // not a session expiry. Let the SSO page handle it gracefully.
      if (currentToken) {
        localStorage.clear();
        dispatch({ type: 'accountData/logOut' });

        if (isEmbedded()) {
          sendSessionExpired();
        } else {
          window.location.href = '/';
        }
      }
    }
    return error;
  }
);

export const AXIOS_INSTANCE = AXIOS_INSTANCE_WITHOUT_INTERCEPTOR;
